export default "<p>\n  site-meta-add works!\n</p>\n"